







import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'SearchCard',
  props: {
    name: String,
    address: String,
    link: Object as PropType<{
      name: String;
      params: {
        id: String;
      };
    }>,
  },
});
